import { useEffect, useState } from 'react';

import { SignupConfig, useSignupApi } from './use-signup-api.hook';

/** One read of /signup/config per page load, shared by every page that offers Google. */
let pending: Promise<SignupConfig | null> | null = null;

/** For tests: forget the cached answer. */
export const resetGoogleClientIdCache = () => {
    pending = null;
};

/**
 * The Google OAuth client id the API is set up with: `undefined` while it is
 * read, `null` when Google sign-in is off (or the API cannot be reached).
 */
export function useGoogleClientId(): string | null | undefined {
    const api = useSignupApi();
    const [clientId, setClientId] = useState<string | null | undefined>(undefined);
    useEffect(() => {
        let live = true;
        if (!pending) pending = Promise.resolve(api.config()).catch(() => null);
        pending.then((c) => live && setClientId(c?.googleClientId || null));
        return () => {
            live = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return clientId;
}
